export type GeocoderResult = google.maps.GeocoderResult;
export type PlaceAutocompleteResult = google.maps.places.AutocompletePrediction;

export enum AddressType {
  /**
   * Table 1: Types supported in place search and addition
   *
   * You can use the following values in the types filter for place searches and when adding a place.
   *
   * @see https://developers.google.com/places/web-service/supported_types#table1
   */

  /**
   * Table 2: Additional types returned by the Places service
   *
   * The following types may be returned in the results of a place search, in addition to the types in table 1 above.
   * For more details on these types, refer to [Address Types](https://developers.google.com/maps/documentation/geocoding/intro#Types)
   * in Geocoding Responses.
   *
   * @see https://developers.google.com/places/web-service/supported_types#table2
   */
  /**
   * indicates a first-order civil entity below the country level. Within the United States, these administrative levels are states.
   * Not all nations exhibit these administrative levels. In most cases, `administrative_area_level_1` short names will closely match
   * ISO 3166-2 subdivisions and other widely circulated lists; however this is not guaranteed as our geocoding results are based
   * on a variety of signals and location data.
   */
  administrative_area_level_1 = 'administrative_area_level_1',
  country = 'country',
  /** indicates an incorporated city or town political entity. */
  locality = 'locality',
  /** indicates a postal code as used to address postal mail within the country. */
  postal_code = 'postal_code',
}
